import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";

var TextContent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TextContent, _Vue);

  function TextContent() {
    var _this;

    _classCallCheck(this, TextContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextContent).apply(this, arguments));
    _this.hidden = true;
    return _this;
  }

  _createClass(TextContent, [{
    key: "spread",
    value: function spread() {
      this.hidden = false;
    }
  }]);

  return TextContent;
}(Vue);

tslib_1.__decorate([Prop({
  default: ""
})], TextContent.prototype, "textData", void 0);

tslib_1.__decorate([Prop({
  default: true
})], TextContent.prototype, "isEllipsis", void 0);

TextContent = tslib_1.__decorate([Component({
  components: {}
})], TextContent);
export default TextContent;